import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import { CButton, CFormLabel, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import AddAddendumOrder from './AddAddendumOrder'
import SaveExtra from '../../services/general/saveExtraData.api'
import AddUpdateOrdersProvider from './AddUpdateOrdersProvider'
import { Pencil, Trash } from 'lucide-react'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderOrder = ({ patientID, noteID, fetchOrdersAgain, headerShow = true, setPastOrders, orders, showHeader = true, patientTreatments, allOrders, setAllOrders, callType = '' , patientDBData ,setPatientDBData , noteCallType  }) => {
  const [ordersData, setOrdersData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [editOrderId, setEditOrderId] = useState('')
  const [deleteID, setDeleteId] = useState(null)
  const [deleteVisible, setDeleteVisible] = useState(false)
  //   const [allOrders, setAllOrders] = useState([])
  const [allOrdersOffline, setAllOrdersOffline] = useState([])
  const addendumDate = new Date()
  const addendumsyncDate = `${String(addendumDate.getMonth() + 1).padStart(2, '0')}-${String(addendumDate.getDate()).padStart(2, '0')}-${addendumDate.getFullYear()}`

  const {
    getOfflineData,
    saveOfflineData,
    getProviderDetails,
    getOpenChartOfflineData,
    saveOpenChartOfflineData
  } = useIndexedDB()
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const getProvidersMaster = async () => {
    // setIsPageLoading(true)
    try {
      // Fetch provider data
              const getProviderDetailsData = await getProviderDetails()

      setLoggedUserProvider(getProviderDetailsData || {})
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [])
const fetchOfflineData = async () => {
  const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
  if (data) {
    console.log(data?.[loggedUserProvider?.ID]?.[patientID], 'data?.[loggedUserProvider?.ID]?.[patientID]', noteID)
    setAllOrdersOffline(data?.[loggedUserProvider?.ID]?.[patientID]?.ordersData?.filter((item) => item?.medication?.noteID === (parseInt(noteID) === 0 ? 0 : parseInt(noteID) )) || [])
  }
}

  useEffect(() => {
    fetchOfflineData()
  }, [loggedUserProvider])

  console.log(allOrdersOffline,'allOrdersOffline')
  useEffect(() => {
    // fetchOrdersAgain()
    fetchOfflineData()
  }, [patientID, noteID])

  // const deleteOrder = async () => {
  //   const updatedOrders = orders.filter((order) => order.id !== deleteID)

  //   console.log('ordersDelete', updatedOrders , orders)
  //   await PatientOrdersCRUD('DELETE', deleteID);
  //   setPastOrders(updatedOrders)
  //   setDeleteId(null)
  //   setDeleteVisible(false)
  // }

   const deleteOrder = async () => {
      const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
      const loggedUser = await getProviderDetails()
      const loggedUserID = loggedUser?.ID
      const userData = { ...(data[loggedUserID] || {}) }
      const patientData = { ...(userData[patientID] || {}) }
      const existingOrder = patientData.ordersData || []
      const newlyAddedData = patientData.newlyAddedData || []
      const newlyAddedOrder = patientData?.newlyAddedData?.ordersData || []

         const updateOrder = {
           id: deleteID,
           shouldDelete: true,
         }
       

    const updateOrders = existingOrder.filter((order) => order.id !== deleteID)

    const isExistingOrder = newlyAddedOrder.some((item) => item?.id === deleteID)

    const updateNewlyOrders = isExistingOrder ? newlyAddedOrder.map((item) => (item?.id === deleteID ? updateOrder : item)) : [...newlyAddedOrder, updateOrder]

      console.log('updateOrders', updateOrders, updateNewlyOrders, newlyAddedOrder)
      const updatedPatientData = {
        ...patientData,
        ordersData: updateOrders,
        newlyAddedData: { ...newlyAddedData, ordersData: updateNewlyOrders },
      }

      const updatedUserData = {
        ...userData,
        [patientID]: updatedPatientData,
      }

      const updatedData = {
        ...data,
        [loggedUserID]: updatedUserData,
      }

      console.log('ordeer update in ls ', updatedData)
      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData)  : await saveOfflineData(updatedData)


     setDeleteId(null)
     setDeleteVisible(false)
      await fetchOrdersAgain()
      await fetchOfflineData()
      setPatientDBData(updatedPatientData)
   }

  console.log('data callType', callType)
  const userData = JSON.parse(localStorage.getItem('jwt_token'))
  const role = userData?.Role

  return (
    <div className="mt-3">
      <div className={`d-flex ${showHeader ? ' justify-content-between' : 'justify-content-end'} `}>
        {/* {showHeader && <h5 style={{ color: 'white', display: headerShow ? 'block' : 'none' }}>Order</h5>} */}

        {callType === 'addendum' && (
          <div className="px-2 d-flex  gap-2">
            <CButton
              color="primary"
              variant="outline"
              size="sm"
              style={{
                backgroundColor: 'blue',
                color: '#fff',
                borderRadius: '10px',
                padding: '6px 16px',
                border: 'none',
              }}
              onClick={() => {
                setOrderModalVisible(true)
              }}
            >
              Add Order
            </CButton>
          </div>
        )}
      </div>
      <div className="  px-3 mt-3   rounded    ">
        {allOrders.map((item, idx) => {
          const currentOrder = item
          return (
            <div key={idx} className="mb-4 " style={{ border: '0.6px solid #989898', borderRadius: '10px', background: '#191919' }}>
              <div
                className="p-2 d-flex justify-content-between align-items-center"
                style={{
                  borderBottom: role === 'provider' ? '1px solid rgba(255, 255, 255, 0.15)' : '1px solid #ccc',
                }}
              >
                <div>
                  <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                  {(() => {
                    if (!addendumsyncDate) return
                    console.log(' addendumsyncDate', addendumsyncDate)
                    const parts = addendumsyncDate?.split('-')
                    if (!parts || parts.length !== 3) return ''
                    const [month, day, year] = parts
                    const date = new Date(`${year}-${month}-${day}`)
                    return new Intl.DateTimeFormat('en-US', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    }).format(date)
                  })()}
                </div>
              </div>
              <div className="p-2">
                {/* Date */}
                {currentOrder?.diagnosis && (
                  <p className=" " style={{ marginTop: ' ' }}>
                    <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                  </p>
                )}
                {/* Imaging */}
                {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                  <div className="mb-2">
                    <p className="text-secondary fw-bold mb-1">Imaging</p>
                    <ul>
                      {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                        <li className="p-0 m-0" key={iIdx}>
                          {imagingItem?.type}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Labs */}
                {currentOrder?.lab?.labs?.length > 0 && (
                  <div className="mb-2">
                    <p className="text-secondary fw-bold mb-1">Labs</p>
                    <ul>
                      {currentOrder.lab.labs.map((labItem, lIdx) => (
                        <li className="p-0 m-0" key={lIdx}>
                          {labItem?.lab}
                          {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Medications */}
                {currentOrder?.medication?.medication?.length > 0 && (
                  <div className="mb-2">
                    <p className="text-secondary fw-bold mb-1">Medications</p>
                    <ul>
                      {currentOrder.medication.medication.map((medItem, mIdx) => (
                        <li className="p-0 m-0" key={mIdx}>
                          {medItem?.name} {medItem?.dosage} {medItem?.route}
                          {medItem?.frequency && ` ${medItem.frequency}`}
                          {medItem?.reason && ` - ${medItem.reason}`}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Miscellaneous */}
                {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                  <div className="mb-2">
                    <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                    <ul>
                      {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                        <li className="p-0 m-0" key={xIdx}>
                          {miscItem}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>

      <div className="   px-3  rounded   " style={{}}>
        {allOrdersOffline?.length > 0 ? (
          allOrdersOffline.map((item, idx) => {
            const currentOrder = item?.medication
            return (
              <div key={idx} className="mb-3 " style={{ border: '0.6px solid #989898', borderRadius: '10px', background: '#191919' }}>
                <div className="">
                  <div
                    className="p-2 d-flex justify-content-between align-items-center"
                    style={{
                      borderBottom: role === 'provider' ? '1px solid rgba(255, 255, 255, 0.15)' : '1px solid #ccc',
                    }}
                  >
                    <div>
                      <CFormLabel className="p-0 m-0 fw-bold">Date :</CFormLabel>
                      {(() => {
                        if (!item?.date) return
                        console.log('item?.date', item?.date)
                        const parts = item?.date?.split('-')
                        if (!parts || parts.length !== 3) return ''
                        const [month, day, year] = parts
                        const date = new Date(`${year}-${month}-${day}`)
                        return new Intl.DateTimeFormat('en-US', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        }).format(date)
                      })()}
                    </div>
                    <div className="d-flex">
                      <span className="d-block p-2" onClick={() => setEditOrderId(item.id)}>
                        <Pencil size={20} />
                      </span>
                      <span
                        className="d-block p-2"
                        onClick={() => {
                          setDeleteVisible(true)
                          setDeleteId(item.id)
                        }}
                      >
                        <Trash size={20} />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="p-2">
                  {currentOrder?.diagnosis && (
                    <p className="mb-1 py-2" style={{ marginTop: '-8px' }}>
                      <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                    </p>
                  )}

                  {/* Imaging */}
                  {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                    <div className="mb-2">
                      <p className="  fw-bold mb-1">Imaging</p>
                      <ul>
                        {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                          <li className="p-0 m-0" key={iIdx}>
                            {imagingItem?.type}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Labs */}
                  {currentOrder?.lab?.labs?.length > 0 && (
                    <div className="mb-2">
                      <p className="  fw-bold mb-1">Labs</p>
                      <ul>
                        {currentOrder.lab.labs.map((labItem, lIdx) => (
                          <li className="p-0 m-0" key={lIdx}>
                            {labItem?.lab}
                            {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Medications */}
                  {currentOrder?.medication?.medication?.length > 0 && (
                    <div className="mb-2">
                      <p className="  fw-bold mb-1">Medications</p>
                      <ul>
                        {currentOrder.medication.medication.map((medItem, mIdx) => (
                          <li className="p-0 m-0" key={mIdx}>
                            {medItem?.name} {medItem?.dosage} {medItem?.route}
                            {medItem?.frequency && ` ${medItem.frequency}`}
                            {medItem?.reason && ` - ${medItem.reason}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Miscellaneous */}
                  {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                    <div className="mb-2">
                      <p className="  fw-bold mb-1">Miscellaneous</p>
                      <ul>
                        {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                          <li className="p-0 m-0" key={xIdx}>
                            {miscItem}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )
          })
        ) : (
          <div
            style={{
              color: role === 'provider' ? 'gray' : '',
            }}
            className={`text-center py-3 ${role === 'provider' ? '' : 'text-muted'}`}
          >
          {callType === 'addendum' ? '' :"No orders available."}
          </div>
        )}
      </div>

      <CModal size="xl" backdrop="static" visible={editOrderId !== ''} onClose={() => setEditOrderId('')} aria-labelledby="StaticBackdropExampleLabel">
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <AddUpdateOrdersProvider
            fetchOrdersAgain={fetchOrdersAgain}
            setEditOrderIdx={setEditOrderId}
            editOrderId={editOrderId}
            patientID={patientID}
            noteID={noteID}
            toggleModal={() => setEditOrderId('')}
            allOrders={allOrders}
            setAllOrders={setAllOrders}
            fetchOfflineData={fetchOfflineData}
            patientDBData={patientDBData}
            setPatientDBData={setPatientDBData}
          />
        </CModalBody>
      </CModal>

      <CModal size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <AddAddendumOrder patientID={patientID} fetchOrdersAgain={fetchOrdersAgain} noteID={noteID} toggleModal={() => setOrderModalVisible((p) => !p)} allOrders={allOrders} setAllOrders={setAllOrders} />
        </CModalBody>
      </CModal>

      <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#191919',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#191919',
            color: 'white',
          }}
        >
          <p>Are you sure you want to delete this Order?</p>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#191919',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            onClick={() => {
              setDeleteVisible(false)
            }}
            className="text-white"
            color="secondary"
            variant="outline"
          >
            Close
          </CButton>
          <CButton onClick={() => deleteOrder()} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default ProviderOrder
